import { Component, Injector, OnInit } from '@angular/core';
import { BasePermissionService } from 'tnx-admin-service/authorization/basepermission/services';
import { RoleType, UserGroupType } from 'tnx-admin-service/authorization/constants';
import { PermissionService } from 'tnx-admin-service/authorization/permission/services';
import { RoleService } from 'tnx-admin-service/authorization/role/services';
import { AutoCompletePickerControlSchema, ComponentContextService, CustomControlSchema, DataFormBase, EntityPickerColumn, EventData, Filter, FormSchemaBase, Operator, TextAreaControlSchema, TextControlSchema, TreeDataOption } from 'tnx-shared';

@Component({
    selector: 'role-form',
    templateUrl: './role-form.component.html',
    styleUrls: ['./role-form.component.scss'],
    providers: [ComponentContextService],
})
export class RoleFormComponent extends DataFormBase implements OnInit {

    selectedTreeNode: any;
    isExpand = true;
    functionTreeData: any;
    dsQuyen: any;

    constructor(
        protected _injector: Injector,
        private _roleService: RoleService,
        private _permissionService: PermissionService,
        private _basePermissionService: BasePermissionService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._roleService;
        this.functionTreeData = [];
        this.model.data.permissionIds = [];
        this.dsQuyen = [];

        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã'
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Tên'
            }),
            new AutoCompletePickerControlSchema({
                mdWidth: 12,
                field: 'roleIds',
                label: 'Kế thừa từ vai trò',
                title: 'Chọn vai trò',
                displayField: 'name',
                baseService: this._roleService,
                defaultFilters: () => {
                    const filters = <Filter[]>[];
                    if (this.model.data.id) {
                        filters.push(this.newFilter('id', Operator.notEqual, this.model.data.id));
                    }
                    filters.push(this.newFilter('type', Operator.equal, RoleType.Group.toString()));
                    return filters;
                },
                columns: [
                    new EntityPickerColumn({
                        code: 'code',
                        label: 'Mã vai trò',
                        operator: Operator.contain,
                    }),
                    new EntityPickerColumn({
                        code: 'name',
                        label: 'Tên vai trò',
                        operator: Operator.contain,
                    })
                ]
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            }),
            new CustomControlSchema({
                field: 'permission',
                label: 'Quyền thao tác',
                mdWidth: 12
            })
        ];
    }

    expand(nodes) {
        this.isExpand = !this.isExpand;
        this.doExpand(nodes);
    }

    doExpand(nodes) {
        for (const node of nodes) {
            if (node.children) {
                node.expanded = this.isExpand;
                for (const cn of node.children) {
                    this.doExpand(node.children);
                }
            }
        }
    }

    async getDetailCustom() {
        return await this._roleService.getDetailCustom(this.model.data.id, this._commonService.guidEmpty());
    }

    async modifyDetailData(data) {
        // chuyển sang lấy dữ liệu trong api
        // data.permissionIds = data.roleHasPermissions.map(x => x.idPermission);
        // data.roleIds = data.roleHasRoles.map(x => x.idRoleParent);
        this.getFunctionTree();
    }

    async onFormInitialized(formEvent: EventData) {
        if (!this.model.data.id) {
            formEvent.model.type = UserGroupType.Group;
            formEvent.model.permissionIds = [];
            this.getFunctionTree();
        }
    }

    async getFunctionTree() {
        // tslint:disable-next-line:no-console
        const data = (await this._permissionService.getAll([], 'id,name,idParent,orderNo')).data;
        data.forEach(element => {
            if (this.model.data.permissionIds.find(x => x == element.id) != null) {
                element.status = 'checked';
            }
        });

        this.functionTreeData = this._crudService.getTreeDataWithOrder(data, 'idParent', 'orderNo', <TreeDataOption>{ displayField: 'name', shortDisplayField: 'name' }, null);
        this.appendKeyToTreeNode(this.functionTreeData);

        this.functionTreeData.forEach(x => {
            this.markCorssed(x);
        });
    }

    appendKeyToTreeNode(treeNodes, parentKey?) {
        treeNodes.forEach((node, i) => {
            node.key = parentKey != null ? `${parentKey}_${i}` : `${i}`;
            if (node.children && node.children.length) {
                this.appendKeyToTreeNode(node.children, node.key);
            }
        });
    }

    async handleNodeSelect() {
        if (this.selectedTreeNode) {
            this.dsQuyen = (await this._basePermissionService.getDataCustomRoute(
                    'GetByPermission', [this.newFilter('idPermission', Operator.equal, this.selectedTreeNode.data.id)])
            ).data;
        }
    }

    checkNode(node) {
        switch (node.data.status) {
            case 'crossed':
                node.data.status = 'checked';
                this.doCheckChildren(node);
                break;
            case 'checked':
                node.data.status = 'unchecked';
                this.removePermissionId(node.data.id);
                this.doUncheckChildren(node);
                this.doUncheckParent(node);
                break;
            default:
                if (node.children) {
                    node.data.status = 'crossed';
                }
                else {
                    node.data.status = 'checked';
                    this.doCheckChildren(node);
                }
                this.addPermissionId(node.data.id);
                this.doCheckParent(node);
        }
    }

    doCheckParent(node) {
        if (node.parent) {
            if (node.parent.children.find(x => x.data.status != 'checked') != null) {
                node.parent.data.status = 'crossed';
            }
            else {
                node.parent.data.status = 'checked';
            }
            this.addPermissionId(node.parent.data.id);
            this.doCheckParent(node.parent);
        }
    }


    doCheckChildren(node) {
        if (node.children) {
            node.children.forEach(child => {
                child.data.status = 'checked';
                this.addPermissionId(child.data.id);
                this.doCheckChildren(child);
            });
        }
    }

    doUncheckParent(node) {
        if (node.parent) {
            if (node.parent.children.some(x => x.data.status == 'checked' || x.data.status == 'crossed')) {
                node.parent.data.status = 'crossed';
            }
            else {
                node.parent.data.status = 'unchecked';
                this.removePermissionId(node.parent.data.id);
            }
            this.doUncheckParent(node.parent);
        }
    }

    doUncheckChildren(node) {
        if (node.children) {
            node.children.forEach(child => {
                child.data.status = 'unchecked';
                this.removePermissionId(child.data.id);
                this.doUncheckChildren(child);
            });
        }
    }

    addPermissionId(id) {
        if (!this.model.data.permissionIds.some(x => x == id)) {
            this.model.data.permissionIds.push(id);
        }
    }

    removePermissionId(id) {
        this.model.data.permissionIds = this.model.data.permissionIds.filter(x => x != id);
    }

    markCorssed(node) {
        if (node.data.status != 'checked') {
            return;
        }

        if (node.children) {
            node.children.forEach(child => {
                this.markCorssed(child);
            });

            if (node.children.some(x => x.data.status != 'checked')) {
                node.data.status = 'crossed';
            }
        }
    }

}

